module.exports = __webpack_public_path__ + "img/img23.10e57c82.png";